<template>
  <div class="user-cta">
    <Icon name="grCameraOff" width="36" class="mb-3"/>
    <div class="mb-5">
      <h4 class="user-cta__title">{{ $t('pages.checkins.no_photo_found_selfie') }}</h4>
      <h5 class="user-cta__subtitle">{{ $t('pages.checkins.no_photo_found_selfie_subtitle') }}</h5>
    </div>
    <b-button class="user-cta__action has-icon" variant="primary" @click="onClick">
      <Icon name="faceId" width="26"/>
      {{ $t('pages.checkins.search_with_selfie') }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: "CtaFaceCheckin",
  props: {
    eventName: {
      type: String,
      required: true
    },
    picaCode: {
      type: String,
      required: true
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>


<style scoped>

</style>